import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { z } from "zod";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";

import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql.ts";
import { PreferredRoomsForm } from "@/components/room/preferred/preferred-rooms-form";

const PreferredRoomsUnitPageQuery = graphql(/* GraphQL */ `
  query PreferredRoomsUnitPageQuery($codUnidade: Int!) {
    unidade: unidades_by_pk(codUnidade: $codUnidade) {
      ...PreferredRoomsFormFragment
    }
  }
`);

const unitIdParamsSchema = z.object({
  unitId: z.string(),
});

const PreferredRoomsUnitPage = (): JSX.Element => {
  const { unitId } = Route.useParams();
  const codUnidade = Number(unitId);

  const queryResult = useGraphQL(PreferredRoomsUnitPageQuery, {
    codUnidade,
  });

  const { data } = queryResult;
  const unidade = data?.unidade;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Salas preferenciais" />
      </HeaderRoot>
      <Page className="p-6">
        <AsyncDataWrapper {...queryResult}>
          {unidade ? <PreferredRoomsForm data={unidade} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/preferred-rooms/$unitId",
)({
  component: PreferredRoomsUnitPage,
  parseParams: (params) => unitIdParamsSchema.parse(params),
  stringifyParams: (params) => params,
});
